import { Upload } from "@mui/icons-material";
import { authenticationService } from "../AuthinticationService";
import restApi from "./RestApi";

const getCurrentRadiologist = () => {
  return authenticationService.currentUserValue;
};

const RadiologistApi = {
  getAllDashboardData: async (filtersArr) => {
    const id = getCurrentRadiologist().profile.UserID;
    return await restApi.post(
      `Radiologist/${id}/dashboard/getAll`,
      filtersArr
    );
  },

  addAnnotation: async (annotationAttrs) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;

      const response = await restApi.post(
        `Radiologist/${id}/annotations/add`,
        annotationAttrs
      );
      return response;
    } catch (error) {
      console.error("Error fetching patients:", error);
      throw error;
    }
  },
  getAnnotations: async (examId) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const response = await restApi.get(
        `Radiologist/${id}/annotations/getAll/${examId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching annotations:", error);
      throw error;
    }
  },
  getAllPatients: async (filtersArr) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const response = await restApi.post(
        `Radiologist/${id}/patients/getAll`,
        filtersArr
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching patients:", error);
      throw error;
    }
  },
  getAllCasesByPatient: async (patientID) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;

      const response = await restApi.post(
        `Radiologist/${id}/patient/cases/${patientID}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching patient cases:", error);
      throw error;
    }
  },

  getAllSites: async () => {
    const id = getCurrentRadiologist().profile.UserID;
    return await restApi.get(
      `Radiologist/${id}/sites/getAll`
    );
  },

  getExamsCount: async (patientId) => {
    const id = getCurrentRadiologist().profile.UserID;
    return await restApi.get(
      `Radiologist/${id}/patients/${patientId}/exams/count`
    );
  },

  getLastExams: async (patientId) => {
    const id = getCurrentRadiologist().profile.UserID;
    return await restApi.get(
      `Radiologist/${id}/patients/${patientId}/exams/last`
    );
  },
  uploadDicom: async (formData) => {
    const id = getCurrentRadiologist().profile.UserID;
    return await restApi.postFiles(`Radiologist/${id}/dicom/upload`, formData);
  },
  createPatient: async (patientData) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const response = await restApi.post(
        `Radiologist/${id}/patients/createPatient`,
        patientData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating patient: ", error);
    }
  },

  createCase: async (caseData) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const response = await restApi.post(
        `Radiologist/${id}/patients/createCase`,
        caseData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating patient:", error);
      throw error;
    }
  },
  getResults: async (examId) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const links = await restApi.post(
        `Radiologist/${id}/patients/getResults`,
        { examId }
      );
      return links.data;
    } catch (error) {
      console.error("Error creating patient:", error);
      throw error;
    }
  },
  updateAnnotation: async (data) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const res = await restApi.post(`Radiologist/${id}/annotations/edit`, {
        data,
      });
      return res;
    } catch (error) {
      console.error("Error creating patient:", error);
      throw error;
    }
  },

  deleteAnnotation: async (annotationId) => {
    const id = getCurrentRadiologist().profile.UserID;
    const res = await restApi.post(`Radiologist/${id}/annotations/delete`, {
      annotationId,
    });
  },
  createReport: async (accessionNumber, reportData = {}) => {
    try {
      const userId = getCurrentRadiologist().profile.UserID;

      const res = await restApi.post(
        `Radiologist/${userId}/report/create/${accessionNumber}`,
        {
          examId: accessionNumber,
          createdBy: userId,
          ...reportData,
        }
      );

      return res.data;
    } catch (err) {
      console.error("Error creating report:", err);
      throw err;
    }
  },
  updateReport: async (accessionNumber, reportData) => {
    try {
      const userId = getCurrentRadiologist().profile.UserID;
      const res = await restApi.post(
        `Radiologist/${userId}/report/update/${accessionNumber}`,
        {
          examId: accessionNumber,
          ...reportData,
        }
      );

      return res.data;
    } catch (err) {
      console.error("Error updating report:", err);
      throw err;
    }
  },
  updateAccount: async (accountData) => {
    try {
      const userId = getCurrentRadiologist().profile.UserID;

      // Only send editable fields (ignore read-only like email/position)
      const payload = {
        first_name: accountData.first_name,
        last_name: accountData.last_name,
        phone: accountData.phone,
      };

      const res = await restApi.post(
        `Radiologist/${userId}/account/update`,
        payload
      );

      return res.data;
    } catch (err) {
      console.error("Error updating account:", err);
      throw err;
    }
  },

  getReport: async (accessionNumber) => {
    const userId = getCurrentRadiologist().profile.UserID;
    return await restApi.get(`Radiologist/${userId}/report/${accessionNumber}`);
  },

  getSettingsInfo: async () => {
    const userId = getCurrentRadiologist().profile.UserID;
    return await restApi.get(`Radiologist/${userId}/setings`);
  },

  deleteCase: async (accessionNumber) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const response = await restApi.post(
        `Radiologist/${id}/patients/deleteCase`,
        { accessionNumber }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting case:", error);
      throw error;
    }
  },

  deletePatient: async (patientId) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const response = await restApi.post(
        `Radiologist/${id}/patients/deletePatient`,
        { patientId }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting patient:", error);
      throw error;
    }
  },
  markCaseOpened: async (patientId, accessionNumber) => {
    try {
      const id = getCurrentRadiologist().profile.UserID;
      const response = await restApi.post(
        `Radiologist/${id}/patients/${patientId}/${accessionNumber}/open`,
        {}
      );
      return response.data;
    } catch (error) {
      console.error("Error marking case as opened:", error);
      throw error;
    }
  },

  presignDicom: async ({ accessionNumber, fileName, size }) => {
    const id = getCurrentRadiologist().profile.UserID;
    const res = await restApi.post(`Radiologist/${id}/dicom/presign`, {
      accessionNumber,
      fileName,
      size,
      contentType: "application/zip",
    });
    return res.data;
  },

  commitDicom: async ({
    accessionNumber,
    key,
    fileName,
    patientData,
    caseData,
    etag,
  }) => {
    const id = getCurrentRadiologist().profile.UserID;
    const res = await restApi.post(`Radiologist/${id}/dicom/commit`, {
      accessionNumber,
      key,
      fileName,
      patientData,
      caseData,
      etag,
    });
    return res;
  },
};

export default RadiologistApi;
